/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["እኩለ ሌሊት","ቀ","ጥዋት1","ከሰዓት1","ማታ1","ሌሊት1"],["እኩለ ሌሊት","ቀትር","ጥዋት1","ከሰዓት 7","ማታ1","ሌሊት1"],["እኩለ ሌሊት","ቀትር","ጥዋት1","ከሰዓት 7 ሰዓት","ማታ1","ሌሊት1"]],[["እኩለ ሌሊት","ቀትር","ጥዋት","ከሰዓት በኋላ","ማታ","ሌሊት"],["እኩለ ሌሊት","ቀትር","ጥዋት1","ከሰዓት በኋላ","ማታ","ሌሊት"],u],["00:00","12:00",["06:00","12:00"],["12:00","18:00"],["18:00","24:00"],["00:00","06:00"]]];
